import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGustoLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 630 630",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 630,
		height: 630,
		fill: "#F05E4E"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M366.104 187.883C366.317 183.692 366.474 180.737 366.654 177.333H412.718C412.831 178.872 413.022 180.31 413.022 181.759C413.022 240.014 413.258 298.268 412.954 356.522C412.752 394.868 395.832 424.461 362.744 443.583C332.567 461.02 301.164 461.189 269.83 445.673C268.032 444.774 266.358 443.64 264.133 442.303L286.963 402.294C308.074 413.192 328.32 412.889 346.993 397.879C360.351 387.149 366.227 372.678 365.924 354.758C340.083 369.656 313.4 373.375 285.413 365.005C265.252 359.144 247.65 346.671 235.439 329.592C209.115 293.291 209.519 246.305 236.697 210.982C251.262 191.553 272.768 178.499 296.727 174.546C321.062 170.311 343.925 174.782 366.104 187.883ZM313.456 219.487C284.593 219.869 262.291 242.8 262.583 271.809C262.864 299.807 286.48 323.39 313.815 322.985C342.42 322.57 366.104 298.684 365.497 270.899C364.755 241.575 342.015 219.083 313.456 219.487Z",
		fill: "#FEFDFD"
	})]
});
export { SvgGustoLogo as ReactComponent };
